// Re-export shared axios instance and helpers
export { api, API } from "@/lib/auth-context";
import { api } from "@/lib/auth-context";

export const createCase = (language) =>
  api.post("/cases", language ? { language } : {}).then((r) => r.data);
export const sendChat = (caseId, message) =>
  api.post(`/cases/${caseId}/chat`, { message }).then((r) => r.data);
export const summarizeCase = (caseId) =>
  api.post(`/cases/${caseId}/summarize`).then((r) => r.data);
export const saveContact = (caseId, contact) =>
  api.post(`/cases/${caseId}/contact`, contact).then((r) => r.data);
export const uploadDocument = (caseId, file, onProgress) => {
  const form = new FormData();
  form.append("file", file);
  return api
    .post(`/cases/${caseId}/upload`, form, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: onProgress,
    })
    .then((r) => r.data);
};
export const getCase = (caseId) =>
  api.get(`/cases/${caseId}`).then((r) => r.data);

export const submitSmsLead = (payload) =>
  api.post(`/sms/lead`, payload).then((r) => r.data);
